import React, { ComponentProps } from 'react';
import { DefaultView, View, Views } from '../../types/BlockWithViews';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { PageMembershipMatchingRulesDefaultView } from './views/PageMembershipMatchingRulesDefaultView';

import { PageMembershipMatchingRulesReportsView } from './views/PageMembershipMatchingRulesReportsView';
import { ViewModeSwitch } from '../../_lib/components/ViewModeSwitch/ViewModeSwitch';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { PageMembershipMatchingRulesSiteMapView } from './views/PageMembershipMatchingRulesSiteMapView';

type PageMembershipMatchingRuleListBlockProps = Views<
  DefaultView<PageMembershipMatchingRulesDefaultView> &
  View<'reports', PageMembershipMatchingRulesReportsView> &
  View<'areaSiteMap', PageMembershipMatchingRulesSiteMapView>
>;

function PageMembershipMatchingRuleList({ views }: PageMembershipMatchingRuleListBlockProps) {
  const { t } = useSonTranslation('PageMembershipMatchingRuleList');

  return (
    <>
      <ViewModeSwitch
        headlineText={searchParams =>
          searchParams.get('active-view') === 'pagemembershipmatchingrulelist.reports'
            ? t('viewTitleReports')
            : t('viewTitleRules')}
        switches={[
          { href: views.default.href, text: t('viewTitleRules'), default: true },
          { href: views.reports.href, text: t('viewTitleReports') },
          { href: views.areaSiteMap?.href, text: t('viewTitleSiteMap') },
        ]}
      >
        {(searchParams) => {
          const currentView = searchParams.get('active-view') || '';

          return (
            <>
              {currentView === 'pagemembershipmatchingrulelist.reports' && views.reports
                ? (
                    <PageMembershipMatchingRulesReportsView {...views.reports} />
                  )
                : null}
              {currentView === 'pagemembershipmatchingrulelist.default' || !currentView
                ? (
                    <PageMembershipMatchingRulesDefaultView {...views.default} />
                  )
                : null}
              {currentView === 'pagemembershipmatchingrulelist.areaSiteMap'
                ? (
                    <PageMembershipMatchingRulesSiteMapView {...views.areaSiteMap} />
                  )
                : null}
            </>
          );
        }}
      </ViewModeSwitch>
    </>
  );
}

export const PageMembershipMatchingRuleListBlock = asFetchableBlock(
  PageMembershipMatchingRuleList,
  BlockType.pagemembershipmatchingrulelist,
);
export type PageMembershipMatchingRuleListBlock = ComponentProps<typeof PageMembershipMatchingRuleListBlock>;
